import React from 'react'

import { ButtonClean, Icon } from '@fourthwall/components'
import { NewWindowIcon } from '@fourthwall/icons'

import type { AnalyticsReportDefinition } from '../../../../types'
import { useGoogleAnalytics } from '../../hooks/useGoogleAnalytics'
import * as S from './GoogleAnalyticsReportBottomContent.styled'

type GoogleAnalyticsReportBottomContentProps = {
  reportId?: AnalyticsReportDefinition['id']
}

export const GoogleAnalyticsReportBottomContent = ({
  reportId,
}: GoogleAnalyticsReportBottomContentProps) => {
  const { reportLinks } = useGoogleAnalytics()

  const googleAnalyticsLink = reportLinks && reportId ? reportLinks[reportId] : undefined

  return (
    <S.Container>
      This data comes from Google Analytics and is gathered from the moment you added the
      integration.{` `}
      {googleAnalyticsLink && (
        <ButtonClean
          appearance="secondary"
          label={
            <S.Label>
              View in Google Analytics
              <Icon component={NewWindowIcon} height={10} />
            </S.Label>
          }
          href={googleAnalyticsLink}
          target="_blank"
        />
      )}
    </S.Container>
  )
}
